import * as React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Link from './link';

const Header = ({ location, isDarkThemeActive, toggleActiveTheme }) => (
  <StaticQuery
    query={graphql`
      query headerTitleQuery {
        site {
          siteMetadata {
            headerTitle
            githubUrl
            helpUrl
            tweetText
            logo {
              link
              image
            }
            headerLinks {
              link
              text
            }
          }
        }
      }
    `}
    render={(data) => {
      const logoImg = require('./images/viture-logo.svg');

      const {
        site: {
          siteMetadata: { headerTitle, githubUrl, helpUrl, tweetText, logo, headerLinks },
        },
      } = data;

      const finalLogoLink = logo.link !== '' ? logo.link : 'https://www.viture.com/';

      return (
        <div className={'navBarWrapper'}>
          <nav className={'navBarDefault'}>
            <a href="https://www.viture.com/dashboard?scene=store" target="_blank" className={'navBarBrand'}>ORDER NOW</a>
            <div className={'navBarHeader'}>
              <Link to={finalLogoLink}>
                <img
                  className={'img-responsive displayInline'}
                  src={logo.image !== '' ? logo.image : logoImg}
                  alt={'logo'}
                />
              </Link>
            </div>
            <a href="https://www.viture.com/dashboard" target="_blank" className={'navBarBrand'}>FEATURES</a>
          </nav>
        </div>
      );
    }}
  />
);

export default Header;
